import {EntityCard} from './entity-card.model';
import {actions} from '~utils/ngrx-util';

const entityName = 'EntityCard';
const {add, adds, upsert, upserts, update, updates, remove, removes, load, clear} = actions<EntityCard>(entityName);

export const addEntityCard = add;
export const addEntityCards = adds;
export const upsertEntityCard = upsert;
export const upsertEntityCards = upserts;
export const updateEntityCard = update;
export const updateEntityCards = updates;
export const deleteEntityCard = remove;
export const deleteEntityCards = removes;
export const loadEntityCards = load;
export const clearEntityCards = clear;
